import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20warm%20toned%20abstract%20composition%20with%20soft%20glowing%20translucent%20circles%20and%20subtle%20play%20button%20geometric%20shapes%20floating%20in%20space%20cinematic%20atmosphere%20with%20coral%20and%20amber%20gradients%20warm%20ambient%20lighting%20editorial%20quality%20artistic%20background&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
        alt="福利视频导精选内容聚合平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-5 leading-tight">
            {siteConfig.name}
            <span className="block text-xl md:text-2xl font-body font-light mt-2 text-background-50/90">
              精选内容聚合平台
            </span>
          </h1>
          <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
            {siteConfig.description}
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-grid-line"></i>
              浏览视频分类
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/30 transition-colors"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}